import { render, staticRenderFns } from "./TaskNode.vue?vue&type=template&id=4240a786&scoped=true"
import script from "./TaskNode.vue?vue&type=script&lang=js"
export * from "./TaskNode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4240a786",
  null
  
)

export default component.exports